(function($) {
    const menuMobileI18n = window.cbThemeI18n?.menuMobile || {};

    class MenuMobile {
        constructor(element) {
            this.element = element;
            this.menuIsActive = false;
            this.menu = element.querySelector('.c-menu-mobile__menu');
            this.toggler = element.querySelector('.c-menu-mobile__toggler');
            this.header = element.closest('.header');
            this.submenuPanel = element.querySelector('.c-menu-mobile__submenu-panel');
            this.submenuTitle = element.querySelector('.c-menu-mobile__submenu-title');
            this.submenuContent = element.querySelector('.c-menu-mobile__submenu-content');
            this.submenuBackButton = element.querySelector('.c-menu-mobile__submenu-back');
            this.activeSubMenuLink = null;

            if (!this.menu || !this.toggler) {
                return;
            }

            if (this.menu.parentElement !== document.body) {
                document.body.appendChild(this.menu);
            }

            this.initSubMenus();
            this.initSubMenuPanel();
            this.initLanguageDropdown();
            this.toggler.addEventListener('click', () => this.toggleMenu());
            document.addEventListener('keydown', (event) => this.handleKeydown(event));
            document.addEventListener('click', (event) => this.handleOutsideClick(event));
        }

        isMobileViewport() {
            return window.matchMedia('(max-width: 991px)').matches;
        }

        toggleMenu(forceState) {
            const nextState = typeof forceState === 'boolean' ? forceState : !this.menuIsActive;

            if (!nextState) {
                this.closeActiveSubMenu();
            }

            this.menu.classList.toggle('is-active', nextState);
            this.toggler.classList.toggle('is-open', nextState);
            if (this.header) {
                this.header.classList.toggle('header--mobile-menu-open', nextState);
            }
            this.toggler.setAttribute('aria-expanded', String(nextState));
            this.toggler.setAttribute('aria-label', nextState ? menuMobileI18n.close : menuMobileI18n.open);
            this.menu.setAttribute('aria-hidden', String(!nextState));
            this.menuIsActive = nextState;

            this.toggleOverflow();
        }

        initSubMenuPanel() {
            if (!this.submenuBackButton) {
                return;
            }

            this.submenuBackButton.addEventListener('click', () => {
                this.closeActiveSubMenu(true);
            });
        }

        initSubMenus() {
            const baseUrl = '/wp-content/themes/centrum-bezdechu';
            const submenuLinks = this.menu.querySelectorAll('.menu-item-has-children > a');

            submenuLinks.forEach((link) => {
                if (!link.querySelector('.dropdown-toggle')) {
                    link.insertAdjacentHTML('beforeend', `<span class="dropdown-toggle" aria-hidden="true"><img src="${baseUrl}/dist/img/icon-arrow-dropdown.svg" alt=""></span>`);
                }

                const dropdownToggle = link.querySelector('.dropdown-toggle');
                const submenu = link.nextElementSibling;

                if (!dropdownToggle || !submenu || !submenu.classList.contains('sub-menu')) {
                    return;
                }

                dropdownToggle.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    if (!this.isMobileViewport()) {
                        return;
                    }

                    this.openSubMenu(link, submenu);
                });

                link.addEventListener('click', (event) => {
                    if (!this.isMobileViewport()) {
                        return;
                    }

                    event.preventDefault();
                    this.openSubMenu(link, submenu);
                });
            });
        }

        getMenuItemLabel(link) {
            const linkClone = link.cloneNode(true);
            linkClone.querySelectorAll('.dropdown-toggle').forEach((toggle) => toggle.remove());
            return linkClone.textContent.trim();
        }

        openSubMenu(link, submenu) {
            if (!this.submenuPanel || !this.submenuContent || !this.submenuTitle) {
                return;
            }

            const submenuClone = submenu.cloneNode(true);
            submenuClone.style.display = 'block';
            submenuClone.removeAttribute('style');

            this.closeActiveSubMenu();
            this.activeSubMenuLink = link;
            link.classList.add('active');
            this.submenuTitle.textContent = this.getMenuItemLabel(link);
            this.submenuContent.replaceChildren(submenuClone);
            this.submenuPanel.classList.add('is-active');
            this.submenuPanel.setAttribute('aria-hidden', 'false');

            if (this.submenuBackButton) {
                this.submenuBackButton.focus();
            }
        }

        closeActiveSubMenu(restoreFocus = false) {
            if (this.activeSubMenuLink) {
                this.activeSubMenuLink.classList.remove('active');
            }

            if (this.submenuPanel) {
                this.submenuPanel.classList.remove('is-active');
                this.submenuPanel.setAttribute('aria-hidden', 'true');
            }

            if (this.submenuContent) {
                this.submenuContent.replaceChildren();
            }

            if (this.submenuTitle) {
                this.submenuTitle.textContent = '';
            }

            if (restoreFocus && this.activeSubMenuLink) {
                this.activeSubMenuLink.focus();
            }

            this.activeSubMenuLink = null;
        }

        closeAllSubMenus() {
            this.closeActiveSubMenu();
        }

        initLanguageDropdown() {
            this.languageSwitcher = this.menu.querySelector('.c-menu-mobile__lang-switcher');

            if (!this.languageSwitcher) {
                return;
            }

            const summary = this.languageSwitcher.querySelector('.c-menu-mobile__lang-toggle');

            if (!summary) {
                return;
            }

            summary.addEventListener('click', (event) => {
                event.preventDefault();

                if (this.languageSwitcher.hasAttribute('open')) {
                    this.languageSwitcher.removeAttribute('open');
                    return;
                }

                this.languageSwitcher.setAttribute('open', 'open');
            });
        }

        handleKeydown(event) {
            if (event.key === 'Escape' && this.menuIsActive) {
                this.closeAllSubMenus();

                if (this.languageSwitcher) {
                    this.languageSwitcher.removeAttribute('open');
                }

                this.toggleMenu(false);
            }
        }

        handleOutsideClick(event) {
            if (!this.menuIsActive) {
                return;
            }

            if (this.languageSwitcher && this.languageSwitcher.hasAttribute('open') && !this.languageSwitcher.contains(event.target)) {
                this.languageSwitcher.removeAttribute('open');
            }

            if (!this.element.contains(event.target) && !this.menu.contains(event.target)) {
                this.closeAllSubMenus();
                this.toggleMenu(false);
            }
        }

        toggleOverflow() {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            const rootElement = document.documentElement;
            const openClass = 'is-mobile-menu-open';
            const usesLenis = rootElement.classList.contains('lenis');

            document.dispatchEvent(new CustomEvent('mobilemenu:toggle', {
                detail: {
                    isActive: this.menuIsActive,
                    scrollbarWidth,
                },
            }));
            
            if (usesLenis) {
                document.body.style.paddingRight = this.menuIsActive ? `${scrollbarWidth}px` : '0';
                return;
            }

            if (this.menuIsActive) {
                rootElement.classList.add(openClass);
                document.body.classList.add(openClass);
                document.body.style.paddingRight = `${scrollbarWidth}px`;
            } else {
                rootElement.classList.remove(openClass);
                document.body.classList.remove(openClass);
                document.body.style.paddingRight = '0';
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const element = document.querySelector('.js-menu-mobile');

        if (element) {
            new MenuMobile(element);
        }
    });
    
    $(document).ready(function(){
        if (!window.matchMedia('(max-width: 1199px)').matches) {
            $('.menu-item-has-children').hover(
                function() {
                    $(this).find('ul.sub-menu').css('display', 'flex');
                }, 
                function() {
                    $(this).find('ul.sub-menu').css('display', '');
                }
            );
        }
    });
})(jQuery);